import React, { useEffect, useRef, useState } from "react";
import { FlatList, ImageBackground, Pressable, ScrollView, StyleSheet, Switch, Text, TextInput as ReactText, TouchableOpacity, View, Alert, NativeSyntheticEvent, TextInputKeyPressEventData } from "react-native";
import { MyButton, TextInputTemp } from "./buttonsAndControls";
import { Checkbox, IconButton, Modal, Portal, TextInput, Provider as PaperProvider } from "react-native-paper";
import DropDownPicker from "react-native-dropdown-picker";
import { DEBUG, ResultSet, enablePromise, openDatabase } from "react-native-sqlite-storage";
import { header, profileName, stopCodes } from "./StockAwareTempData";
import Backdated from "./DateTimeCheck";
import createAndSavePDF from "./pdfCreate";
const darkColour='#2a2d3e';

interface ChildViewData {
  id: number;
  texts: string[];
}

interface SalesRecord {
  ID: number;
  Customer_Name: string;
  Phone_Number: string;
  Date: string;
  Payment_Method: string;
  Total: number;
  Discount: number;
  After_Discount: number;
}

interface SellList {
  ID: number;
  Quantity: number;
  Board: string;
  Customer: string;
  Payment_Method: string;
	Notes: string;
  Delivered: string;
	Item_Price: number;
  Total: number;
  Discount: number;
  After_Discount: number;
}

interface IsValid {
  valid: boolean;
}


const ToBeSold = ({ texts, delPressed, isChecked, onCheckboxChange, index, lessThan, } : ChildViewData & 
  { delPressed: () => void, lessThan: boolean; isChecked: boolean; onCheckboxChange: (value: boolean) => void; index: number; }) => {

  const isEvenIndex = index % 2 === 0;
  const backgroundColor = isEvenIndex ? '#E6E6E6' : '#F5F5F5';
	const [hovered, setHovered] = useState(false);
	const [isOpacity, setIsOpacity] = useState(false);
  const sizes: number[] = [57, 290, 300, 100, 150];
  return (
    <View style={{ backgroundColor }}>
      <TouchableOpacity>
			<Pressable style={{...stylesBox.purchasedTouchable,  
          backgroundColor: hovered ? '#CCCCCC' : lessThan ? 'red' : 'transparent', 
          opacity: isOpacity ? 0.2 : 1 }}
          onHoverIn={() => setHovered(true)}
          onHoverOut={() => setHovered(false)}
          onPressIn={() => setIsOpacity(true)}
          onPressOut={() => setIsOpacity(false)}
			>
        {texts.map((text, i) => (
          <View key={i} style={{...stylesBox.viewStyle, width: sizes[i] }} >
            <Text key={i} style={stylesBox.textStyle}>
              {text}
            </Text>
          </View>
        ))}
        <View style ={{width:38, height:35, borderWidth:0, borderRightWidth:2, borderColor:'black', }}>
          <Checkbox
            status={isChecked ? 'checked' : 'unchecked'}
            onPress={() => onCheckboxChange(!isChecked)}
            color= {darkColour}
          />
        </View>
				{hovered &&
          <IconButton icon={'trash-can-outline'} size={25} focusable={false} iconColor={darkColour}  
          style={stylesBox.iconButtonStyle}
          onPress={() => delPressed()}
				/>
				}
				</Pressable>
      </TouchableOpacity>
    </View>
  );
};

const ChildView = ({ texts, isChecked, onPressed, index, delPressed,
}: ChildViewData & { isChecked: boolean; onPressed: () => void;
  index: number; delPressed: (()=> void); }) => {

  const isEvenIndex = index % 2 === 0;
  const backgroundColor = isEvenIndex ? '#E6E6E6' : '#F5F5F5';
  const [hovered, setHovered] = useState(false);
	const [isOpacity, setIsOpacity] = useState(false);
  const sizes: number[] = [180, 158, 108 , 105 ];
  return (
    <View style={{ backgroundColor }}>
      <TouchableOpacity>
				<Pressable style={{... stylesBox.childPressable, backgroundColor: isChecked 
						? darkColour : hovered ? '#CCCCCC' : 'transparent', opacity: isOpacity ? 0.2 : 1}}
					onPress={() => {onPressed();}}
					onHoverIn={() => setHovered(true)}
					onHoverOut={() => setHovered(false)}
					onPressIn={() => setIsOpacity(true)}
					onPressOut={() => setIsOpacity(false)}
				>
        {texts.map((text, i) => (
          <View key={i} style={{...stylesBox.viewStyle, width: sizes[i] }}>
            <Text key={i} style={{...stylesBox.textStyle, color: isChecked ? 'white' : darkColour }}>
              {text}
            </Text>
          </View>
        ))}
        {hovered &&
					<IconButton icon={'trash-can-outline'}size={25} focusable={false} iconColor={isChecked ? 'white' : darkColour}  
					style={{justifyContent:'center', padding:0, margin:0, marginLeft: -5, alignContent:'center'}}
					onPress={() => delPressed()} />
				}

				</Pressable>
      </TouchableOpacity>
    </View>
  );
};

const SavedForLater = () => {
  header('Saved For Later')
  const [isSwitchOn, setIsSwitchOn] = useState(false);
  const [searchText, setSearchText] = useState('');
	const [filteredResult, setFilteredResult] = useState<SalesRecord[]>([]);
	const [sales, setSales] = useState<SalesRecord[]>([]);
	const [sellItems, setSellItems] = useState<SellList[]>([]);
  const [validQuantity, setValidQuantity] = useState<IsValid[]>([]);
  const [oneOnly, setOneOnly] = useState('');
  const [totalDue, setTotalDue] = useState(' ');
  const computerDateTime = new Date();
  const [resultReceived, setResultReceived] = useState('');
  const [result, setResult] = useState('');
  const [showBackdated, setShowBackdated] = useState(true)
  const salesData: { qty: string; desc: string; amt: string; }[] = [];
  const receiptData = ({
    name: '', address: '', phone: '', salesID: '', salesPerson: '', date: '', payment: '', customer: '', total: '', discount: '', totalPaid: ''
  })
  const [phoneOptionalError, setPhoneOptionalError] = useState(false)
  const [errorPhone, setErrorPhone] = useState(false);

	
  const fetchStocks = async () => {
		DEBUG(true);
		enablePromise(true);
		const initDB =  openDatabase({name: 'StockAware.db', location:'default'});
    (await initDB).transaction((tx) => {
			tx.executeSql(
        `SELECT * FROM SFLSales_Record ORDER BY ID DESC`,
        [],
        (_, results) => {
          const rows = results.rows;
          const salesArray: SalesRecord[] = [];
          for (let i = 0; i < rows.length; i++) {
            salesArray.push(rows.item(i) as SalesRecord);
          }
          setSales(salesArray);
					setFilteredResult(salesArray);
					const updatedCheckedItems: boolean[] = Array.from(
						{ length: salesArray.length },
						() => false
					);
        },
        (error) => {
          console.error('Error executing SQL', error);
        }
      );
    })
  }

  const CreateTables = async () => {
    DEBUG(true);
    enablePromise(true);
    const initDB = openDatabase({ name: 'StockAware.db', location: 'default' });
    (await initDB).transaction((tx) => {
      tx.executeSql(
        "CREATE TABLE IF NOT EXISTS SFLSales_Record (ID INTEGER PRIMARY KEY AUTOINCREMENT, " +
        "Customer_Name TEXT, Phone_Number TEXT, Date DATETIME, Payment_Method TEXT, Total REAL, Discount REAL, After_Discount REAL);"
      );
  
      tx.executeSql(
        "CREATE TABLE IF NOT EXISTS SFLSales_Items (ID INTEGER PRIMARY KEY AUTOINCREMENT, " +
        "Sales_ID INTEGER, Quantity INTEGER, Board TEXT, Customer TEXT, Payment_Method TEXT, Date DATETIME, Delivered TEXT, " + 
        "Notes Text, Item_Price REAL, Total REAL, Discount REAL, After_Discount REAL, FOREIGN KEY (Sales_ID) REFERENCES Sales_Record (ID)); "
      );
    });
  }
  

  useEffect(() => {
		if (stopCodes) {
			try {
        CreateTables()
				fetchStocks();
					console.log('Stocky')
			} catch (error) {
					console.log(error)
			}
			setTimeout (() => {
			},200)
		};
  }, [stopCodes]);

    useEffect(() => {
      if (stopCodes) {
        const filterChildViews = async () => {
          const filteredViews = await filterViews() as SalesRecord[];
          setFilteredResult(filteredViews);
        };
    
        filterChildViews();
      }
    }, [sales, searchText, stopCodes]);

    useEffect(() => {
      if (stopCodes) {
        let amt = 0
        {sellItems.forEach((row) => {
          if (!isNaN(row.Total) ){
          amt = amt + row.Total
          } 
          })
        }
        setTotalDue(amt.toString())
      };
    }, [sellItems, stopCodes])
    		
	
  const handleSearchTextChange = (value: string) => {
    setSearchText(value);
		//filterData(value);
  };

  const filterViews = async () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const filteredViews = sales.filter((child) => {
          const hasTextMatch = (child.Customer_Name.toLowerCase() + (child.Payment_Method ? child.Payment_Method.toLowerCase() 
					: '')).includes(searchText.toLowerCase())
          const hasIdMatch = child.ID.toString().includes(searchText.toLowerCase());
          return hasTextMatch || hasIdMatch;
					
        });

        resolve(filteredViews);
      }, 0);
    });
  };

  const filterData = (query: string) => {
    const filteredResults = sales.filter((item) =>
      item.Customer_Name.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredResult(filteredResults);
  };

  const deleteSelected = async (id: number) => {
    const updatedChildViews = sellItems.filter((item) => item.ID !== id);
    setSellItems(updatedChildViews);
    const initDB = openDatabase({ name: 'StockAware.db', location: 'default' });
      (await initDB).transaction((tx) => {
        tx.executeSql(
          `DELETE FROM SFLSales_Items WHERE ID = ?;`, [id],
        )
      })
  };

  const deleteFromSales = async (id: number) => {
    const updatedChildViews = sales.filter((item) => item.ID !== id);
    setSales(updatedChildViews);
    if (id.toString() === oneOnly) {
      setSellItems([])
      setOneOnly('')
      setValue('')
      setCustomerName('')
      setPhone('');
      setDiscount('');
    }
    const initDB = openDatabase({ name: 'StockAware.db', location: 'default' });
      (await initDB).transaction((tx) => {
        tx.executeSql(
          `DELETE FROM SFLSales_Items WHERE Sales_ID = ?;`, [id],
        )
        tx.executeSql(
          `DELETE FROM SFLSales_Record WHERE ID = ?;`, [id],
        )
      })
   
  };

  const handlePreesed = ( ID: string, name: string, pm: string, discount: string, phone: string) => {
		if (oneOnly === ID.toString()) {
			setOneOnly('')
      setSellItems([])
      setValue('')
      setCustomerName('')
      setPhone('');
      setDiscount('');
		} else {
			setOneOnly(ID)
      setValue(pm)
      setCustomerName(name)
      showSalesRow(ID)
      setDiscount(discount);
      setPhone(phone);
		}

	};

  const onToggleSwitch = () => {
    setIsSwitchOn(!isSwitchOn);
  };

  const handleBackdated = () => {
    setShowBackdated((prev) => !prev)
  };

  const CheckDateTime = async () => {
    DEBUG(true);
    enablePromise(true);
    const initDB = openDatabase({ name: 'StockAware.db', location: 'default' });
    
    return new Promise(async (resolve, reject) => {
      try {
      (await initDB).transaction((tx) => {
        tx.executeSql(
          'CREATE TABLE IF NOT EXISTS StoredDateTime (ID INTEGER PRIMARY KEY, DateTime TEXT NOT NULL)',
          []
        );
        tx.executeSql('SELECT DateTime FROM StoredDateTime WHERE ID = ?', [1], (_, results) => {
          if (results.rows.length > 0) {
            const storedDateTime = new Date(results.rows.item(0).DateTime);
           
            if (storedDateTime > computerDateTime) {
              setResultReceived('Backdated')
              resolve(results); // Resolve the promise with the existing results
              
            } else  if (storedDateTime < computerDateTime) {
              tx.executeSql('UPDATE StoredDateTime SET DateTime = ? WHERE ID = ?', [computerDateTime.toISOString(), 1], (_, updateResults) => {
                // if (updateResults.rowsAffected > 0) {
                   setResultReceived('All good')
                // }
                resolve(updateResults); // Resolve the promise when the update is completed
              });
            }
          } else {
            tx.executeSql('INSERT INTO StoredDateTime (ID, DateTime) VALUES (?, ?)', [1, computerDateTime.toISOString()], (_, insertResults) => {
              // if (insertResults.rowsAffected > 0) {
                 setResultReceived('First time')
              // }
              resolve(insertResults); // Resolve the promise when the insertion is completed
            });
          }
        });
      });
    } catch (Error:any) {
      setResultReceived ('Error')
      reject(Error)
      console.log(Error)
    }
    }); 
  };

  function generateReceiptID(): string {
    const timestamp = new Date().toISOString().replace(/[^0-9]/g, ''); // Format: YYYYMMDDHHMMSS
    const randomPart = Math.floor(Math.random() * 10000).toString().padStart(4, '0'); // 4-digit random number
    
    const receiptID = `SARCPT${timestamp}-${randomPart}`;
    return receiptID;
  }

  const proceedToReceipt = async () => {
    const _salesID = generateReceiptID();
    salesData.splice(0, salesData.length);
    setResult('');
    await CheckDateTime();
    if (resultReceived === 'Backdated') {
      setShowBackdated(true);
      setResult('ShowBackdated');
    } else {
      setShowBackdated(false);

      let goAhead = true;
      
      for (const entry of validQuantity) {
        if (entry.valid === false) {
          goAhead = entry.valid
        }
      }
      console.log(goAhead)
      if (goAhead) {
        if (sellItems.length > 0) {
          const initDB = openDatabase({ name: 'StockAware.db', location: 'default' });
          (await initDB).transaction((tx) => {
            let _companyName = '';
            let _companyPhone = '';
            let _companyAddress = '';

            tx.executeSql(`SELECT * FROM Company;`, [], (_, result) => {
              if (result.rows.length > 0) {
                if (result.rows.item(0).Phone_1 && result.rows.item(0).Phone_2) {
                  _companyPhone = result.rows.item(0).Phone_1 + ', ' + result.rows.item(0).Phone_2;
                } else if (result.rows.item(0).Phone_1) {
                  _companyPhone = result.rows.item(0).Phone_1;
                } else if (result.rows.item(0).Phone_2) {
                  _companyPhone = result.rows.item(0).Phone_2;
                }
                _companyName = result.rows.item(0).Company_Name;
                _companyAddress = result.rows.item(0).Address
              } else {
                Alert.alert('Company Data not found', 'The company data is not found, it seems it has not yet been set.')
                return
              }
            })
            tx.executeSql(
              "INSERT into Sales_Record (Customer_Name, Sales_Person, Phone_Number, Date, Sales_ID, Payment_Method, Total, Discount, After_Discount) VALUES (?, ?, ?, DATETIME('now', '+1 hour'), ?, ?, ?, ?, ?)",
              [customerName, profileName, phone, _salesID, value, parseInt(totalDue, 10), Number(discount), Number(totalDue) - Number(discount)],
              async (_, insertResult) => {
                if (insertResult.rowsAffected > 0) {
                  const id = insertResult.insertId;
                  let count = 0
                  sellItems.forEach((row) => {
                    count += row.Quantity
                  });
                  sellItems.forEach((row) => {
                    const discountAmt = (Number(discount)/count) * row.Quantity
                    tx.executeSql(
                      `INSERT into Sales_Items (Sales_ID, Quantity, Board, Customer, Payment_Method, Date, 
                        Delivered, Notes, Item_Price, Total, Discount, After_Discount) VALUES (?, ?, ?, ?, ?, DATETIME('now', '+1 hour'), ?, ?, ?, ?, ?, ?);`,
                      [id, row.Quantity, row.Board, customerName, value, row.Delivered, row.Notes, row.Item_Price, row.Total, 
                       discountAmt, row.Total - discountAmt]
                    );
                    tx.executeSql(
                      "UPDATE Stocks SET Quantity = Quantity - ? WHERE Item_Name = ?",
                      [row.Quantity, row.Board]
                    );
                    salesData.push({qty: row.Quantity.toString(), desc: row.Board, amt: String(Number(row.Total).toLocaleString('en-NG', {}))})  
                  });
                  const options: Intl.DateTimeFormatOptions = { hour:'numeric', minute:'numeric', year:'numeric', month:'long', day:'numeric' };
                  receiptData.name = _companyName;
                  receiptData.address = _companyAddress;
                  receiptData.phone = _companyPhone;
                  receiptData.salesID = _salesID;
                  receiptData.salesPerson = profileName;
                  receiptData.date = new Date().toLocaleString('en-US', options);
                  receiptData.payment = value;
                  receiptData.customer = customerName;
                  receiptData.total = String(Number(totalDue).toLocaleString('en-NG', {}));
                  receiptData.discount = '-' + String(Number(discount).toLocaleString('en-NG', {}));
                  receiptData.totalPaid = String((Number(totalDue) - Number(discount)).toLocaleString('en-NG', {}))
                  console.log(receiptData)
                  createAndSavePDF(salesData, receiptData);
                }
              }
            );
            tx.executeSql(
              `DELETE FROM SFLSales_Items WHERE Sales_ID = ?;`, [parseInt(oneOnly, 10)],
            )
  
            tx.executeSql(
              `DELETE FROM SFLSales_Record WHERE ID = ?;`, [parseInt(oneOnly, 10)],
              (_, result) => {
                if (result.rowsAffected > 0) {
                  setSellItems([])
                  setValue('')
                  setCustomerName('')
                  setOneOnly('')
                  setPhone('');
                  setDiscount('');
                  const updatedChildViews = sales.filter((item) => item.ID !== parseInt(oneOnly, 10));
                  setSales(updatedChildViews);
                }
              }
            )
          });
  
  
        } else {
          Alert.alert('Empty List!', 'There is no sales to process')
        }
      } else {
        Alert.alert('Greater than available!', 
        'The quantity of one or more selected boards is greater than \nwhat is available in stock. Check red items.')
      }
     
    }
  };

  // const showSalesRow = async (iD: string) => {
  //   const initDB = openDatabase({ name: 'StockAware.db', location: 'default' });
  
  //   try {
  //     const db = await initDB;
  
  //     await new Promise<void>((resolve, reject) => {
  //       db.transaction((tx) => {
  //         tx.executeSql(
  //           'SELECT * FROM SFLSales_Items WHERE Sales_ID = ?',
  //           [iD],
  //           (_, results) => {
  //             const rows = results.rows;
  //             const salesArray: SellList[] = [];
  //             const validBoolean: IsValid[] = [];
  
  //             // Create an array of Promises for the inner queries
  //             const promises = [];
  
  //             for (let i = 0; i < rows.length; i++) {
  //               const promise = new Promise<void>((innerResolve, innerReject) => {
  //                 tx.executeSql(
  //                   'SELECT Quantity FROM Stocks WHERE Item_Name = ?',
  //                   [rows.item(i).Board],
  //                   (_, stockResults) => {
  //                     const stockQty = stockResults.rows;
  //                     if (rows.item(i).Quantity > stockQty.item(0).Quantity) {
  //                       validBoolean.push({ valid: false } as IsValid);
  //                     } else {
  //                       validBoolean.push({ valid: true } as IsValid);
  //                     }
  //                     innerResolve();
  //                   },
  //                   (error) => {
  //                     console.error('Error executing inner SQL', error);
  //                     innerReject(error);
  //                   }
  //                 );
  //               });
  
  //               promises.push(promise);
  //               salesArray.push(rows.item(i) as SellList);
  //             }
  
  //             // Wait for all the inner queries to complete before proceeding
  //             Promise.all(promises)
  //               .then(() => {
  //                 setSellItems(salesArray);
  //                 setValidQuantity(validBoolean);
  //                 resolve();
  //               })
  //               .catch((error) => {
  //                 console.error('Error in inner promises', error);
  //                 reject(error);
  //               });
  //           },
  //           (error) => {
  //             console.error('Error executing SQL', error);
  //             reject(error);
  //           }
  //         );
  //       });
  //     });
  //   } catch (error) {
  //     console.error('Error opening database', error);
  //   }
  // };

  const showSalesRow = async (iD: string) => {
    const initDB =  openDatabase({name: 'StockAware.db', location:'default'});
    const salesArray: SellList[] = [];
    const validBoolean: IsValid[] = [];
    (await initDB).transaction(async (tx) => {
      tx.executeSql(
        'SELECT * FROM SFLSales_Items WHERE Sales_ID = ? ',
        [iD],
        async (_, results) => {
          const rows = results.rows;
           for (let i = 0; i < rows.length; i++) {
             tx.executeSql(
              'SELECT Quantity FROM Stocks WHERE Item_Name = ? ',
              [rows.item(i).Board],
              (_, results) => {
                const stockQty = results.rows;
                rows.item(i).Quantity > stockQty.item(0).Quantity
                ? validBoolean.push({valid: false} as IsValid)
                : validBoolean.push({valid: true} as IsValid) 
              },
              (error) => {
                console.error('Error executing SQL', error);
              }
            );
            salesArray.push(rows.item(i) as SellList);
          }
        },
        (error) => {
          console.error('Error executing SQL', error);
        }
      );
    }).then(() => {
        setSellItems(salesArray);
        setValidQuantity(validBoolean);
      })
	};

  const handlePhone = (text:string) => {
    const digitsOnly = text.replace(/[^0-9]/g, '');
    setPhone(digitsOnly)
  }
  
  const handleDiscount = (text:string) => {
    const digitsOnly = text.replace(/[^0-9]/g, '');
    setDiscount(digitsOnly)
    
  }
  
  
  
  const switchText = isSwitchOn ? 'Checkbox shown' : 'Checkbox hidden';
	const [open, setOpen] = useState(false);
  const [value, setValue] = useState('');
  const [items, setItems] = useState([
    {label: 'Cash', value: 'Cash', icon: () => <IconButton icon="cash" iconColor={darkColour} size={25} style={{width:34, height:34, padding:4}} containerColor='white' focusable={false} />},
    {label: 'POS', value: 'POS', icon: () => <IconButton icon="credit-card" iconColor={darkColour} size={25} style={{width:34, height:34, padding:4}} containerColor='white' focusable={false} />},
		{label: 'Bank transfer', value: 'Bank transfer', icon: () => <IconButton icon="bank-transfer" iconColor={darkColour} size={25} style={{width:34, height:34, padding:4}} containerColor='white' focusable={false} />}

	]);
  const [customerName, setCustomerName] = useState('');
  const [phone, setPhone] = useState('');
  const [discount, setDiscount] = useState('');
  const [afterDiscount, setAfterDiscount] = useState('');
  const [amountDue, setAmountDue] = useState(0)
  const [handleChecked, setHandleChecked] = useState(true)

	return (
		<PaperProvider>
      <View style={{ flex: 1 }}>
        <View style={stylesBox.mainView}>
          <View style={stylesBox.searchMainContainer}>
						<View style={{ flexDirection: 'row', width:380 }}>
            <TextInput
								mode="outlined"
								label={'Search stock'}
								placeholder="Search"
								underlineColor={darkColour}
								activeOutlineColor={darkColour}
								spellCheck={false}
								contentStyle={stylesBox.searchContentStyle}
								style={{  paddingVertical:1, paddingLeft:15, height: 30 }}
								outlineStyle={{ borderWidth: 0, height: 30, borderRightColor: 'pink' }}
								onChangeText={handleSearchTextChange}
							/>
						</View>
					</View>
        </View>
        <View style={{flexDirection:'row'}}>
          <View style={stylesBox.stockViewBox}>
            <View style={stylesBox.stockViewHeader}>
              <View style={{ ...stylesBox.columnHeaderBox, marginLeft: 0, width: 182, borderLeftWidth: 0 }}>
                <Text style={{ ...stylesBox.columnHeaderText }}>Customer Name</Text>
              </View>
              <View style={{ ...stylesBox.columnHeaderBox, width: 158 }}>
                <Text style={{ ...stylesBox.columnHeaderText }}>Date & Time</Text>
              </View>
              <View style={{ ...stylesBox.columnHeaderBox, width: 108 }}>
                <Text style={{ ...stylesBox.columnHeaderText }}>Payment</Text>
              </View>
              <View style={{ ...stylesBox.columnHeaderBox, width: 100, borderRightWidth: 0 }}>
                <Text style={{ ...stylesBox.columnHeaderText }}>Total (₦)</Text>
              </View>
            </View>
            <ScrollView>
              {filteredResult.map((item, index) => (
                <ChildView
                  key={item.ID}
                  texts={[item.Customer_Name, item.Date, item.Payment_Method, 
                    item.Total ? Number(item.Total).toLocaleString('en-NG') : '0.00']}
                  isChecked={oneOnly === item.ID.toString() ? true : false}
                  onPressed={() => handlePreesed( item.ID.toString(), item.Customer_Name, item.Payment_Method, item.Discount?.toString(), item.Phone_Number?.toString())}
                  index={index}
                  id={item.ID}
                  delPressed={() => deleteFromSales(item.ID)}

                />
              ))}
            </ScrollView>
          </View>
          <View style={{flexDirection:'column'}}>
            <View style={stylesBox.sellItemContainer}>
              <View style={stylesBox.sellItemHeader}>
                <View style={{ ...stylesBox.columnHeaderBox, marginLeft: 0, width: 59, borderLeftWidth: 0 }}>
                  <Text style={{ ...stylesBox.columnHeaderText }}>Qty</Text>
                </View>
                <View style={{ ...stylesBox.columnHeaderBox, width: 290 }}>
                  <Text style={{ ...stylesBox.columnHeaderText }}>Board Description</Text>
                </View>
                <View style={{...stylesBox.columnHeaderBox, width: 300}}>
                  <Text style={{...stylesBox.columnHeaderText}}>Notes</Text>
                </View>
                <View style={{...stylesBox.columnHeaderBox, width:100}}>
                  <Text style={{...stylesBox.columnHeaderText}}>Amount (₦)</Text>
                </View>
                <View style={{...stylesBox.columnHeaderBox, width:150 }}>
                  <Text style={{...stylesBox.columnHeaderText}}>Total Amount (₦)</Text>
                </View>
                <View style={{...stylesBox.columnHeaderBox, width:34 }}>
                <IconButton icon="send-check" iconColor='white' size={22} 
                  style={{width:40, height:35, marginTop: 0, padding:4}} 
                  containerColor={darkColour} focusable={false} />
                </View>
                <View style={{ ...stylesBox.columnHeaderBox, width: 36, borderRightWidth:0 }}>
                  <Text style={{ ...stylesBox.columnHeaderText }}></Text>
                </View>
              </View>

              <ScrollView>
                {sellItems.map((item, index) => (
                  <ToBeSold
                    key={item.ID}
                    texts={[item.Quantity.toString(), item.Board, item.Notes, 
                      item.Item_Price ? Number(item.Item_Price).toLocaleString('en-NG') : '0.00', 
                      item.Total ? Number(item.Total).toLocaleString('en-NG') : '0.00']}
                    index={index}
                    id={item.ID}
                    lessThan= {validQuantity[index]?.valid === false ? true : false}
                    isChecked= {item.Delivered === 'Yes' ? true : false}
                    onCheckboxChange={(value)=> { setHandleChecked((prev) => !prev); value ? item.Delivered = 'Yes' : item.Delivered = 'No'; console.log(value, item.Delivered, item.Board)}}
                    delPressed={() => deleteSelected(item.ID)}
                  />
                ))}
              </ScrollView>

              {sellItems.length > 0 &&
                <View style = {{...stylesBox.firstSubView, alignSelf: 'flex-end', borderColor: darkColour, width: 240, marginRight: 2, justifyContent: 'center'}}>
                  <Text style= {{...stylesBox.columnHeaderText, fontWeight:'900', color: darkColour, fontSize: 16, alignSelf: 'center', marginTop: 0}}>
                    {`Sum Total: ${Number(totalDue).toLocaleString('en-NG', { style: 'currency', currency: 'NGN' })}`}
                  </Text>
                </View>
              }

              <View style={{flexDirection:'row', justifyContent: 'space-evenly'}}>
                <View style={{flexDirection:'row'}}>
                  <TextInputTemp 
                    lTxt="" 
                    plhrTxt="    Name of Customer" 
                    cnWidth={200} 
                    lbClr={darkColour} 
                    lbWidth={1} 
                    txtWidth={197} 
                    scTxt={false}
                    onChangeText={(value)=> setCustomerName(value)}
                    value= {customerName}
                  />
                </View>

                <View style={{flexDirection:'row'}}>
                  <TextInputTemp 
                    lTxt="Phone:" 
                    plhrTxt="   Phone number" 
                    cnWidth={260} 
                    lbClr={darkColour} 
                    lbWidth={110} 
                    txtWidth={148} 
                    scTxt={false}
                    value= {phone}
                    optionalError={phoneOptionalError}
                    errorMessage='Phone number may be incorrect'
                    showError = {errorPhone} 
                    focusReceived={()=> setPhoneOptionalError(false)} 
                    onChangeText={handlePhone}
                  />
                </View>
              
                <View style={{width:210, height:40, margin:10}}>
                  <DropDownPicker
                    theme="DARK"
                    modalAnimationType='slide'
                    placeholder='Payment Method'
                    style={{borderRadius:10, height:40}}
                    open={open}
                    value={value}
                    items={items}
                    setOpen={setOpen}
                    setValue={setValue}
                    setItems={setItems}
                    listItemContainerStyle={{backgroundColor:'white'}}
                    listItemLabelStyle={{color:'black', fontFamily:'century gothic', fontSize:16, fontWeight:'300'}}
                    textStyle={{color:'white', fontFamily:'century gothic', fontSize:16, fontWeight:'300'}}
                    placeholderStyle={{color:'white', fontFamily:'century gothic', fontSize:16, fontWeight:'300', textAlign:'center'}}
                    dropDownDirection="TOP"
                  />
                </View>
                {sellItems.length > 0 &&
                <View style={{flexDirection:'row'}}>
                  <TextInputTemp 
                    lTxt="Discount (₦)" 
                    plhrTxt="Enter Discount" 
                    cnWidth={240} 
                    lbClr={darkColour} 
                    lbWidth={110} 
                    txtWidth={168} 
                    scTxt={false}
                    onChangeText={handleDiscount}
                    value= {discount}
                  />
                </View>
                }
              </View>

              <View style={stylesBox.footerContainer}>
                <View style={stylesBox.footerSubContainer}>
                  <Text style={{...stylesBox.columnHeaderText, color:'white', marginTop:0}}>
                    Total amount to pay
                  </Text>
                  <IconButton
                    icon="ray-start-arrow"
                    iconColor= 'white'
                    size={40}
                    focusable={false}
                    style={stylesBox.footerIconStyle}
                  />
                </View>
                <View style={stylesBox.totalContainer}>
                  <Text style= {{...stylesBox.columnHeaderText, fontWeight:'900'}}>
                  {(Number(totalDue) - Number(discount ? discount : '')).toLocaleString('en-NG', { style: 'currency', currency: 'NGN' })}
                  </Text>
                </View>
              </View>
            </View>
            <View style = {{width: 960, alignItems:'center'}}>
              <View style={stylesBox.lastContainer}>
                <View style={{margin:10}}>
                  <MyButton btnText="Proceed to receipt" btnColor={darkColour} hndClicked={proceedToReceipt}/>
                </View>
                {result === 'ShowBackdated' && (
                  <Backdated onClicked={handleBackdated} backdated={showBackdated} />
                )}
              </View>
            </View>
          </View>
        </View>
      </View>
		</PaperProvider>
	)
}

const stylesBox=StyleSheet.create ({
  purchasedTouchable: {
		flexDirection: 'row',
		alignItems: 'center',
		backgroundColor: 'transparent',
		height: 35,
		borderColor: 'black',
		borderTopWidth: 2,
		borderBottomWidth: 2,
		marginTop: -2,
	},
  viewStyle: {
		borderWidth: 2, 
		borderColor: 'black', 
		height: 35, 
		alignItems: 'center', 
		marginLeft: -2, 
		borderTopWidth: 0, 
		borderBottomWidth: 0,
	},
	textStyle: {
		color: darkColour,
		fontFamily: 'century gothic', 
		fontSize: 15, 
		fontWeight: 'normal',
		marginTop: 6,
	},
	childPressable: {
		flexDirection: 'row',
		alignItems: 'center',
		height: 35,
		borderColor: 'black',
		borderTopWidth: 2,
		borderBottomWidth: 2,
		marginTop: -2,
	},
  iconButtonStyle: {
    justifyContent:'center', 
    padding:0, 
    margin:0, 
    marginLeft: -5, 
    alignContent:'center',
  },
  searchMainContainer: {
		flexDirection: 'column',
		backgroundColor: 'white',
		alignSelf: 'center',
		borderWidth: 2,
		borderColor: '#DCE3E8',
		borderRadius: 10,
		marginLeft: 10,
		marginTop: 10,
		marginBottom: 10,
		height: 40
	},
	columnHeaderText: {
	fontFamily:'century gothic', 
	fontSize:15, 
	fontWeight:'normal', 
	textAlign:'center',
	color:'white', 
	marginTop:6
	},
  searchContentStyle: {
    marginTop:-2, 
    marginLeft:-15,
		paddingTop: 2,
		paddingBottom: 0,
		borderWidth: 2,
		borderRightWidth: 0,
		borderRightColor: 'white',
		width: 380,
		height: 30,
		borderRadius: 10,
		borderTopRightRadius: 0,
		borderBottomRightRadius: 0,
		borderColor: 'transparent',
	},
  modalChild: {
    width: 400, 
    height:200, 
    borderWidth:2, 
    borderRadius:10, 
    borderColor:darkColour, 
    backgroundColor:'white',
  },
  modalButtonContainer: {
    width:400, 
    flexDirection:'row-reverse', 
    paddingRight:20
  },
  stockViewBox: {
		width: 580,
		height: 600,
		borderWidth: 2,
		borderColor: '#DCE3E8',
		marginTop: 10,
		marginBottom: 0,
		borderRadius: 10,
		marginLeft: 20,
		marginRight: 20,
		backgroundColor: 'white',
	},
  sellItemContainer: {
    width:960,
    height: 600,
    borderWidth: 2,
    borderColor: '#DCE3E8',
    marginTop: 10,
    marginBottom: 0,
    borderRadius: 10,
    marginLeft: 0,
    marginRight: 20,
    backgroundColor: 'white',
  },
  sellItemHeader: {
    width: 957,
    height: 35,
    backgroundColor: darkColour,
    flexDirection: 'row',
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
  },
	stockViewHeader: {
		width: 577,
		height: 35,
		backgroundColor: darkColour,
		flexDirection: 'row',
		borderTopLeftRadius: 10,
		borderTopRightRadius: 10,
	},
	mainView: {
		flexDirection: 'row', 
		backgroundColor: 'white', 
		borderWidth: 2, 
		borderRadius: 10, 
		marginLeft: 20, 
		marginRight: 20, 
		borderColor: '#DCE3E8',
	},
	firstSubView: {
		borderWidth: 2,
		borderRadius: 10,
		borderColor: '#DCE3E8',
		flexDirection: 'row',
		alignSelf: 'center',
		alignContent: 'center',
		width: 208,
		height: 40,
		margin: 20,
		marginTop: 0,
		marginBottom: 0
	},
	modalContainer: {
		marginLeft:600,
		marginTop: -50,
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: 'white',
		flexDirection:'column-reverse', 
		width:400, 
		height:200, 
		borderWidth:1, 
		borderColor:darkColour, 
		borderRadius:10, 
  },
	notesText: {
    borderWidth: 1,
    borderRadius:10,
    borderColor: '#DCE3E8',
    width:360,
    height:80,
    padding:10,
    color:'black', 
    fontFamily:'century gothic', 
    fontSize:16, 
    fontWeight:'300',
    marginBottom:10,
    marginHorizontal:0,
    alignSelf:'center'
  },

	columnHeaderBox: {
		borderWidth:2, 
		borderColor:'black', 
		width:57,  
		height:35, 
		alignItems:'center',
		marginLeft:-2,
		borderTopWidth:0,
	},
	
	mediumText: {
    color:'grey', 
    fontFamily:'century gothic', 
    fontSize:15, 
    fontWeight:'normal', 
    textAlign:'center',
    marginTop:5
	},
  totalContainer : {
    flexDirection:'row', 
    justifyContent:'center', 
    borderWidth:2, 
    marginRight: 48,
    borderLeftWidth:0, 
    borderRightWidth:0, 
    marginTop:0, 
    borderColor:'white', 
    width:152, 
    height:35, 
    alignSelf: 'center',
  },
  footerContainer : {
    flexDirection:'row', 
    alignSelf:'center', 
    height: 40, 
    backgroundColor: darkColour, 
    borderRadius: 10, 
    borderTopRightRadius: 0, 
    borderTopLeftRadius: 0, 
    alignContent: 'center',
  },
  footerSubContainer : {
    flexDirection:'row', 
    alignSelf:'flex-end', 
    flex: 1, 
    paddingHorizontal: 100, 
    height: 40, 
    justifyContent:'flex-end', 
    alignItems:'center',
  },
  footerIconStyle: {
    marginHorizontal:20, 
    margin: 0, 
    padding: 0, 
    alignSelf: 'center',
  },
  lastContainer : {
    flexDirection:'row', 
    borderRadius:10, 
    borderColor:'#DCE3E8', 
    borderWidth:2, 
    width: 220, 
    marginTop:10, 
    marginRight:20, 
    backgroundColor:'white',
    
  },
			
})

export default SavedForLater;